import React, { useMemo } from 'react';

import { ButtonIconButton } from '@/components/common/Button/';
import { FORM_OPTIONS } from '@/definition/FORM_OPTIONS';
import { CareerHistorySkills } from '@/utils/api-client';

type TFieldProps = {
  index: number;
  item: CareerHistorySkills;
};

export const SkillOriginal: React.VFC<TFieldProps> = (props) => {
  const experienced_skill = useMemo(() => {
    const type = FORM_OPTIONS.experienced_skill.filter(
      (type) => type.value === String(props.item.experience)
    );
    return type.length ? type[0].children : '';
  }, [props.item]);

  return (
    <div className="lg:flex md:flex lg:space-x-8 md:space-x-8 sm:space-y-8">
      <div className="flex space-x-8 flex-1">
        <div className="w-full mkt_mask_items pointer-events-none opacity-40">
          <div className="mbx-formContainer--textfield-wrapper">
            <input
              type="text"
              className="mbx-formContainer mbx-formContainer--textfield"
              placeholder="例）Photoshop"
              value={props.item.name}
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="flex space-x-8">
        <div className="sm:flex-1 lg:w-120 md:w-120 mkt_mask_items pointer-events-none opacity-40">
          <div className="mbx-formContainer--dropdown-wrapper">
            <div className="mbx-formContainer--dropdown-arrow opacity-30">
              <button
                type="button"
                className="hitArea_mini size_default mbx-button-iconButton color-gray hover:text-button-iconButton-gray-hover"
              >
                <i className="mbx-icon mbx-icon-Arrow_Down"></i>
              </button>
            </div>
            <div className="mbx-formContainer--dropdown-multiple-container"></div>
            <div className="mbx-formContainer--dropdown-multiple-placeholder">
              <p>{props.item.level ? props.item.level : ''}</p>
            </div>
          </div>
        </div>
        <div className="sm:flex-1 lg:w-120 md:w-120 mkt_mask_items">
          <div className="mbx-formContainer--dropdown-wrapper pointer-events-none opacity-40">
            <div className="mbx-formContainer--dropdown-arrow opacity-30">
              <button
                type="button"
                className="hitArea_mini size_default mbx-button-iconButton color-gray hover:text-button-iconButton-gray-hover"
              >
                <i className="mbx-icon mbx-icon-Arrow_Down"></i>
              </button>
            </div>
            <div className="mbx-formContainer--dropdown-multiple-container"></div>
            <div className="mbx-formContainer--dropdown-multiple-placeholder">
              <p>{experienced_skill ? experienced_skill : '経験年数'}</p>
            </div>
          </div>
        </div>
        <div className="flex sm:hidden">
          <ButtonIconButton
            type="gray"
            iconName="Sortable"
            className="dragHandle opacity-30"
            disabled
          />
          <ButtonIconButton type="gray" iconName="Clear" className="opacity-30" disabled />
        </div>
      </div>
    </div>
  );
};
